const stats = [
  { num: "17", unit: "Anrufe in Abwesenheit vom Wochenende." },
  { num: "3", unit: "Negative Bewertungen, weil niemand erreichbar war." },
  { num: "12", unit: "Verpasste Verkaufschancen pro Monat." },
  { num: "2", unit: "die nachts trotzdem noch E-Mails beantworten." },
];

export default function Stats() {
  return (
    <section
      id="gallery"
      data-stage="3"
      className="relative py-8 md:py-12 px-6 md:px-12 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto">
        <div
          data-reveal
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16"
        >
          <div>
            <span className="text-xs tracking-[0.4em] uppercase text-moss mb-4 block">
              · ZAHLEN, DIE WIR IMMER WIEDER SEHEN
            </span>
            <h2 className="font-display text-4xl md:text-6xl font-light leading-tight">
              Kennen Sie diese Zahlen?
            </h2>
          </div>
          <p className="text-inkDim text-sm max-w-xs leading-relaxed">
            Diese Zahlen haben wir uns ausgedacht.
            Die Probleme dahinter leider nicht.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line rounded-2xl overflow-hidden border border-line">
          {stats.map((s, i) => (
            <div
              key={s.unit}
              data-reveal
              data-delay={i + 1}
              className="bg-bg/80 px-6 py-10 md:py-14 hover:bg-bgSoft transition-colors group"
            >
              <div className="font-display text-5xl md:text-6xl text-ink font-light tabular-nums mb-3 group-hover:text-sage transition-colors">
                {s.num}
              </div>
              <div className="text-sm text-ink/80 uppercase tracking-[0.2em] mb-2">
                {s.unit}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}